import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'app/core/core.module';
import { StatementsComponent } from './pages/statements/statements.component';
import { StatementsRoutingModule } from './statements-routing.module';
import { TonnageGridComponent } from './components/tonnage-grid/tonnage-grid.component';
import { TollGridComponent } from './components/toll-grid/toll-grid.component';
import { TonnageModule } from '../tonnage/tonnage.module';
import { TollModule } from '../toll/toll.module';
import { ErrorMessageModule } from '@components/error-message/error-message.module';
import { St4wGridComponent } from './components/st4w-grid/st4w-grid.component';
import { SiteListModule } from '@components/site-list/site-list.module';
import { CompanyListModule } from '@components/company-list/company-list.module';
import { ShipListModule } from '@components/ship-list/ship-list.module';
import { MaterialListModule } from '@components/material-list/material-list.module';

@NgModule({
  imports: [
    CommonModule,
    StatementsRoutingModule,
    CoreModule,
    TonnageModule,
    TollModule,
    ErrorMessageModule,
    SiteListModule,
    CompanyListModule,
    ShipListModule,
    MaterialListModule
  ],
  declarations: [
    StatementsComponent,
    TonnageGridComponent,
    TollGridComponent,
    St4wGridComponent
  ]
})
export class StatementsModule { }
